import { formatInTimeZone, toDate } from 'date-fns-tz'

export const formatDateByUserTimeZone = (releaseTimestamp: Date | string, pattern: string = 'MMMM d, yyyy hh:mm a'): string => {
  const utc = toDate(releaseTimestamp, { timeZone: 'UTC' })
  const userTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
  const output = formatInTimeZone(utc, userTimeZone, pattern)
  return output
}
